<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <InputAssetList :asset-kind="assetKind" @item-selected="handleItemSelected" />
</template>

<script setup lang="ts">
import { useDialogStore } from '@/stores/dialogStore'

import type { AssetKind } from '../interfaces'
import type { InputAsset } from '../interfaces/inputAsset.interface'
import { fileUrlByAsset } from '../utils/fileBucketUrl'
import InputAssetList from './InputAssetList.vue'

//! nordy - 콜백 패턴으로 변경 (window CustomEvent 제거)
const { assetKind, onAssetSelected } = defineProps<{
  assetKind: AssetKind
  onAssetSelected: (inputUrl: string) => void
}>()

const dialogStore = useDialogStore()

function handleItemSelected(item: InputAsset) {
  const inputUrl = fileUrlByAsset({ asset: item.asset })
  if (!inputUrl) return

  onAssetSelected(inputUrl)
  //! nordy - 호출자별 dialog key 가 다르므로(예: image/audio/mesh) 활성 dialog 를 닫는다.
  // 하드코딩된 'nordy-select-image' 로는 mesh 모달(key: 'nordy-select-mesh')이 매칭 실패해
  // 모달이 안 닫히는 버그가 있었음.
  dialogStore.closeDialog()
}
</script>
